export default function BottomNavigation(props){

    return (
        <footer className='bg-primary container-fluid'>
            <div className={ "p-3 text-white row align-items-center " + props.className }>
                { props.children }
            </div>
        </footer>
    )
}